export default __webpack_public_path__ + "static/media/logo-white.e659ae32.png";